module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_c('strong', [_vm._v("Foreword")]), _vm._v(" "), _c('em', [_vm._v("by Thom Hartmann")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('strong', [_vm._v("Introduction:")]), _vm._v(" The Crisis of Broken Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART 1")]), _vm._v(" WHY WE MUST FIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1 Enough Is Enough")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("How and Why We Have Limited the Duration, Volume, and Location of Speech")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2 If Money Is Speech, Speech Is No Longer Free")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("The Difference between Paid Speech and Free Speech")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3 Stupidity, Inequality, and Corruption")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("Three Good Reasons to Limit Paid Speech")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4 Who Broke Our Democracy?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("How Courts Have Struck Down Limits on Money in Politics")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART 2")]), _vm._v(" READY FOR ACTION?—LET’S GO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5 Repairing Our Republic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("How the People Can Overturn the Court")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6 Magic Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("What Should a Constitutional Amendment Say?")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7 Instructions for Mission Impossible")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("How to Pass a Constitutional Amendment When Incumbents Don’t Want One")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8 Halfway Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sub"
  }, [_vm._v("We’re Further Along Than You Think")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/epilogue#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Epilogue")]), _vm._v(" "), _c('em', [_vm._v("by Miles Rapoport")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-app"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix I")]), _vm._v(" Resources and Organizations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-app1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app2#app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix II")]), _vm._v(" Sample Voter Instruction Measure from Los Angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/reading#reading",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Recommended Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("We Can Do It")]), _vm._v("—How We Really Can Get Big Money Out of Politics including Three Bonus Chapters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0